<template>
    <section class="report-layout">
        <header class="report-filter">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="fw-bold">Employee Schedule</h6>
                <button type="button" class="btn btn-primary me-2" @click="goToReportCenter()">Report Center</button>
            </div>
            <div class="row col-12 mb-4">
                <div class="filter col-4">
                    <span class="fw-bold pb-1">View<span class="text-danger">*</span></span>
                    <select
                        class="form-select ps-1"
                        name="weekday-range"
                        v-model="employeeScheduleDetails.viewType"
                        @blur="v$.employeeScheduleDetails.viewType.$touch"
                    >
                        <option :value="null">Select View Type</option>
                        <option value="weekly">Weekly</option>
                        <option value="daily">Daily</option>
                    </select>
                    <span v-if="v$.employeeScheduleDetails.viewType.$error" class="field-invalid"
                        >View type is required.</span
                    >
                </div>
                <div class="filter col-4">
                    <span class="fw-bold pb-1">Organization</span>
                    <MultiSelect
                        classes="w-100"
                        :dropDownOptions="agencyMultiSelectOptions"
                        labelText="Organizations"
                        :selectedOptions="employeeScheduleDetails.selectedAgencies"
                        v-on:updateBranches="updateBranches"
                    />
                </div>
                <div class="filter col-4">
                    <span class="fw-bold pb-1">Branch</span>
                    <BranchDefaultFilter
                        classes="w-100"
                        :check-all-by-default="true"
                        :selected-branches="employeeScheduleDetails.selectedBranches"
                        v-on:updateBranches="handleBranchesOnChange"
                        :selected-agencies-name="selectedAgenciesName"
                    />
                </div>
            </div>
            <div class="row col-12 mb-4">
                <div class="filter col-4">
                    <span class="fw-bold pb-1">Task Status</span>
                    <MultiSelect
                        classes="w-100"
                        :dropDownOptions="taskStatusOptions"
                        labelText="Task Status"
                        :selectedOptions="employeeScheduleDetails.selectedTaskStatus"
                        v-on:updateBranches="updateTaskStatus"
                    />
                </div>
                <div class="filter col-4">
                    <span class="fw-bold pb-1">Employees</span>
                    <MultiSelectFilter
                        classes="w-100"
                        :on-fetch="fetchEmployeeList"
                        :selectedItems="employeeScheduleDetails.selectedEmployeesSearch"
                        v-on:selectedItemsUpdated="selectedEmployeesSearchUpdated"
                        :placeholder="`Search for Employee by Name`"
                        name="Employees"
                        :isCalendar="true"
                    />
                </div>
                <div class="filter col-4">
                    <span class="fw-bold pb-1">Start Date<span class="text-danger">*</span></span>
                    <DatePicker :getDate="handleDateChange">
                        <div class="input-group date datepickerInput">
                            <input
                                name="startDate"
                                id="schedule-date"
                                type="text"
                                class="form-control"
                                placeholder="Select Start Date"
                                v-model="employeeScheduleDetails.startDate"
                                @blur="v$.employeeScheduleDetails.startDate.$touch"
                            />
                            <div class="input-group-addon input-group-append">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                        <span v-if="v$.employeeScheduleDetails.startDate.$error" class="field-invalid"
                            >Start Date is required.</span
                        >
                    </DatePicker>
                </div>
            </div>
            <div class="row">
                <div class="col-4 filter">
                    <span class="fw-bold pb-1">Report Format</span>
                    <select
                        class="form-select ps-1"
                        name="weekday-range"
                        v-model="employeeScheduleDetails.reportFormat"
                    >
                        <option value="excel">Excel</option>
                        <option value="pdf">PDF</option>
                    </select>
                </div>
            </div>
        </header>
        <footer class="d-flex align-center justify-content-center mt-4">
            <button type="button" class="btn btn-primary me-2" @click="generateReport()" v-if="!generating">
                Generate Report
            </button>
            <button type="button" class="btn btn-primary me-2" disabled v-if="generating">Generating Report...</button>
            <button type="button" class="btn btn-primary me-2" @click="clearSelection()">Clear</button>
        </footer>
    </section>
</template>
<style lang="scss">
.report-layout .report-filter .multi-select-filter .calendar-dropdown {
    width: 29rem;
}
</style>
<script src="./EmployeeSchedule.ts"></script>
